/* eslint-disable @typescript-eslint/no-explicit-any */
// mediaMessageSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Recipient } from "../interfaces/reducersInterfaces";
import axios from 'axios';
import { sendRecipientDetails } from '../../Utils/recipientDetailsUtils';


// interface MediaUploadResponse {
//   success: boolean;
//   modified_url: string;
//   authorization_credintial: string;
//   url: string;
//   mime_type: string;
//   sha256: string;
//   file_size: number;
//   id: string;
//   messaging_product: string;
//   message: null;
//   phone_number_id: number;
// }

interface MediaSendParams {
  media_link: string;
  type: string;
  caption: string;
  currentRecipient: Recipient;
  scheduled_time?: number;
}

interface MediaMessageState {
  isLoading: boolean;
  error: string | null;
}

export const handleMediaSend = createAsyncThunk(
  'mediaMessage/handleMediaSend',
  async ({ media_link, type, caption, currentRecipient, scheduled_time }: MediaSendParams, { getState }) => {
    // First get media details
    // const retrieveResponse = await axios.post<MediaUploadResponse>(
    //   'https://api.insightssystem.com/api:bVXsw_FD/media/upload', { 
    //     raw_link,
    //     user_id 
    //   },
    // );

    // const { mime_type, id, authorization_credintial, phone_number_id } = retrieveResponse.data;

    // Determine type based on mime_type
    // const type = type

    // Determine endpoint based on mime type
    let endpoint = 'https://api.insightssystem.com/api:uYdlVwac/web/send/';
    if (type === "image") {
      endpoint += 'image';
    } else if (type === "video") {
      endpoint += 'video';
    }else if (type === "audio") {
      endpoint += 'audio';
    } else {
      endpoint += 'document';
    }

    // Send media with caption
    const state = getState() as any;
    const token = state.auth.token;
    
    const sendResponse = await axios.post(
      endpoint,
      {
        media_link: media_link,
        caption: caption,
        currentRecipient,
        type,
        ...(scheduled_time ? { scheduled_time } : {})
      },
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: token })
        }
      }
    );

    // Send recipient details to API
    await sendRecipientDetails(currentRecipient, token);

    return sendResponse.data;
  }
);

const initialState: MediaMessageState = {
  isLoading: false,
  error: null
};

const mediaMessageSlice = createSlice({
  name: 'mediaMessage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(handleMediaSend.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(handleMediaSend.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(handleMediaSend.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to send media';
      });
  }
});

export default mediaMessageSlice.reducer;